"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var sinDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSin: _factoriesAny.createSin
};
exports.sinDependencies = sinDependencies;